<template>
  <div
    class="overlay"
    :class="modifiers"
    v-on="$listeners"
  >
    <slot>
      <div class="overlay__inner" data-animation="fadeInBottom">
        <BaseIcon
          v-if="icon"
          v-bind="icon"
          class="overlay__icon"
        />
        <BaseTitle
          v-if="title"
          v-bind="title"
          class="overlay__title"
        />
        <BaseText
          v-if="description"
          v-bind="description"
          class="overlay__description"
        />
        <div class="overlay__actions">
          <BaseButton
            v-for="(item, i) in actions"
            :key="`overlay_action_${i}`"
            v-bind="item"
            class="overlay__action"
            @click="item.action ? item.action() : null"
          />
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseText from '@/components/BaseText.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'BaseOverlay',
  components: {
    BaseIcon,
    BaseText,
    BaseTitle,
    BaseButton,
  },
  props: {
    icon: {
      type: Object,
      default: null,
    },
    title: {
      type: Object,
      default: null,
    },
    description: {
      type: Object,
      default: null,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    modifiers() {
      return {
        overlay_touch: this.hasClickListener,
      };
    },
    hasClickListener() {
      return Boolean(this.$listeners.click);
    },
  },
};
</script>

<style lang="stylus">
.overlay
  display flex
  align-items center
  justify-content center
  width 100%
  height 100%
  padding 1em
  background alpha($c_text, 90%)
  text-align center
  color $c_light
  &_touch
    cursor pointer

  &__icon
    margin 0 auto
    margin-bottom 1em

  &__description
    max-width 86%
    margin 0 auto

  &__actions
    margin-top 2em

  &__action
    margin-left 0.7em
    margin-right @margin-left
</style>
